<div class="globalContainer">
    <div id="cart">
        <h1>Votre commande</h1>

        @if (isCartLoaded) {
            <div class="campaign">
                <article class="infoItem">
                    <p class="itemTitle">Nom de la campagne</p>
                    <p class="itemValue">{{ campaignName }}</p>
                    <span (click)="goToMap(0)">Modifier</span>
                </article>
                <article class="infoItem">
                    <p class="itemTitle">Dates</p>
                    <p class="itemValue">
                        Du
                        <strong>{{ campaignStartDate | date: 'dd/MM/yyyy' }}</strong>
                        au
                        <strong>{{ campaignEndDate | date: 'dd/MM/yyyy' }}</strong>
                    </p>
                    <span (click)="goToMap(1)">Modifier</span>
                </article>
                <p class="itemTitle">Une diffusion de <strong>10 secondes</strong> toutes les minutes minimum.</p>
                <!-- Face par groupe de parc écran -->
                <div *ngFor="let sp of cartItem.sp" class="screenGroup">
                    <div style="min-height: 50px" class="screenGroupHeader">
                        <!-- Icon Outdoor -->
                        <mat-icon
                            *ngIf="sp.i != 14"
                            style="height: 40px"
                            alt="Ecran Indoor"
                            class="screenTypeImg"
                            svgIcon="store-outdoor"
                        ></mat-icon>
                        <!-- Icon Indoor -->
                        <mat-icon
                            *ngIf="sp.i == 14"
                            style="height: 40px"
                            alt="Ecran Indoor"
                            class="screenTypeImg"
                            svgIcon="store-indoor"
                        ></mat-icon>
                        <span class="screenParkName">
                            <span class="outdoor" *ngIf="sp.i != 14">Ecran Géant bord de route</span>
                            <span class="indoor" *ngIf="sp.i == 14">Ecran Intérieur</span>
                            <br />
                            <span class="screenCount"
                                >{{ sp.fAs.length }} Ecran<ng-container *ngIf="sp.fAs.length > 1">s</ng-container></span
                            >
                        </span>
                        <div class="screenParkPrice">
                            <span>{{ sp.ht | currency: 'EUR' : 'symbol' : undefined : 'fr' }}</span>
                            <br />
                            <span style="font-size: 13px; font-weight: 500; font-style: italic"
                                >{{ sp.tj | currency: 'EUR' : 'symbol' : undefined : 'fr' }} x
                                {{ cartItem.da }} jrs</span
                            >
                        </div>
                    </div>
                    <!-- MARK: Go For FaceList -->
                    <ng-container *ngFor="let face of sp.fAs; let first = first">
                        <hr *ngIf="!first && !face.hide" class="screenTileHR" />

                        <div *ngIf="!face.hide" class="screenTile">
                            <img
                                class="screenImg"
                                alt="Miniature de l'écran"
                                *ngIf="face.ts && face.ts != null && face.ts != ''"
                                src="{{ baseUrl }}/file/getFile/{{ face.ts }}/{{ face.ts }}"
                                (click)="openImgDetail(face.st)"
                            />
                            <div>
                                <p class="screenAddress">{{ face.a }}, {{ face.zc }} {{ face.c }}</p>

                                <p
                                    class="sizeInfo"
                                    matTooltip="Résolution de l'écran:  {{ face.pw }}px * {{ face.ph }}px"
                                >
                                    <span class="material-icons">aspect_ratio</span>
                                    {{ face.pw }}*{{ face.ph }} px -
                                    {{ screen$.getAspectRatio(face.pw, face.ph) }}
                                </p>

                                <p class="screenCode">{{ face.sc }}</p>
                                <p *ngIf="!face.ic || face.nf.length > 0" class="screenWarning">
                                    <span class="warningTitle">
                                        <mat-icon>warning</mat-icon>
                                        Ecran non disponible !
                                    </span>
                                    @if (!face.ic) {
                                        <i>L'activité de votre compte est interdite sur cet écran</i>
                                    } @else if (face.nf.length > 0) {
                                        <!-- Pour chaque Erreur de dates -->
                                        @for (occupedInfo of face.nf; track $index) {
                                            @if ($index <= 2) {
                                                <i>
                                                    {{ getOccupedType(occupedInfo.ic) }} du
                                                    {{ occupedInfo.di | date: 'dd/MM/yyyy' }}
                                                    au
                                                    {{ occupedInfo.da | date: 'dd/MM/yyyy' }}
                                                </i>
                                            } @else if ($index > 2) {
                                                <i>...</i>
                                            }
                                        }
                                    }
                                </p>
                            </div>
                            <p class="faceDaylyPrice">
                                {{ face.ht | currency: 'EUR' : 'symbol' : undefined : 'fr' }}
                                / jour
                            </p>
                        </div>
                    </ng-container>
                    <div *ngIf="sp.fAs.length > 5" class="screenTile">
                        <p class="screenCode" *ngIf="!sp.expend" class="expend" (click)="expendSP(sp)">Voir plus</p>
                        <p class="screenCode" *ngIf="sp.expend" class="expend" (click)="minusSP(sp)">Voir moins</p>
                    </div>
                    <span class="editBtn" (click)="goToMap(2)">Modifier</span>
                </div>

                <div class="spotGroup" *ngIf="cartItem.so != null && cartItem.so.length != 0">
                    <div
                        style="min-height: 50px; margin-bottom: 20px"
                        *ngFor="let spot of cartItem.so"
                        class="screenGroupHeader"
                    >
                        <mat-icon style="height: 40px" class="material-icons screenTypeImg"
                            >play_circle_outline</mat-icon
                        >

                        <span class="screenParkName">
                            <span class="outdoor" *ngIf="spot.t == 0">Création de spot</span>
                            <span class="outdoor" *ngIf="spot.t == 1">Création de template</span>
                        </span>
                        <div class="screenParkPrice">
                            <span>{{ spot.ht }}€</span>
                            <span style="display: block; font-size: 13px; font-weight: 500; font-style: italic"
                                >{{ spot.n }} x {{ spot.uHT }}€</span
                            >
                        </div>
                    </div>
                    <span class="editSpotBtn" (click)="goToSpot()">Modifier</span>
                </div>
            </div>
            <div class="endCartContainer">
                <article class="priceItem">
                    <span class="itemTitle">Total HT</span>
                    <span class="itemValue">{{ cartItem.ht | currency: 'EUR' : 'symbol' : undefined : 'fr' }}</span>
                </article>
                <hr class="priceItemHr" />
                <article class="priceItem">
                    <span class="itemTitle">Total TVA</span>
                    <span class="itemValue">{{ cartItem.ta | currency: 'EUR' : 'symbol' : undefined : 'fr' }}</span>
                </article>
                <hr class="priceItemHr" />
                <article class="priceItem totalPriceItem">
                    <span class="itemTitle">Total TTC</span>
                    <span class="itemValue">{{ cartItem.tt | currency: 'EUR' : 'symbol' : undefined : 'fr' }}</span>
                </article>

                <!-- CGV -->
                <mat-checkbox [disabled]="enableCheckout" [(ngModel)]="isCGVok" [required]="true">
                    J'accepte les
                    <a href="/account-detail/cgv" target="_blank" style="margin-right: 3px">
                        Conditions générales de Vente </a
                    >* (requis)
                </mat-checkbox>
            </div>
        }
        @if (!isCartLoaded) {
            <div class="loadingCart">
                <mat-spinner [diameter]="50"></mat-spinner>
                <i>Chargement de votre panier ...</i>
            </div>
        }

        <button
            *ngIf="!enableCheckout && isCartLoaded"
            [disabled]="!isCartCompatible || !isCartLoaded || isGoingToPay || !isCGVok"
            mat-raised-button
            class="payButton"
            color="primary"
            (click)="goToPay()"
        >
            Aller au paiement
        </button>
        <button *ngIf="!enableCheckout" mat-stroked-button color="secondary" class="backBtn" (click)="goBack()">
            Retour
        </button>

        @if (isGoingToPay) {
            <div class="loadingCard loadingPayment">
                <mat-spinner [diameter]="50"></mat-spinner>
                <i>Chargement du paiement ...</i>
            </div>
        }
        @if (enableCheckout && orderId != null) {
            <div class="loadingPayment">
                <wncm-payment [orderId]="orderId" (cancelPayment)="goBack()"></wncm-payment>
            </div>
        }
    </div>
</div>
